import { render, staticRenderFns } from "./drawerEmergencyContact.vue?vue&type=template&id=254335a2&scoped=true&"
import script from "./drawerEmergencyContact.vue?vue&type=script&lang=js&"
export * from "./drawerEmergencyContact.vue?vue&type=script&lang=js&"
import style0 from "./drawerEmergencyContact.vue?vue&type=style&index=0&id=254335a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254335a2",
  null
  
)

export default component.exports